/** 100 × 50 mm label at 203 dpi (800 × 400 dots). */
export const LABEL_100X50_203DPI = {
  id: "100x50" as const,
  widthIn: 3.94,
  heightIn: 1.97,
  dpi: 203,
  widthDots: 800,
  heightDots: 400,
  margin: 16,
  label: "100 × 50 mm",
  recommendedUse: "Storage bins",
} as const;